function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { ContextConsumer as t } from "../controllers/context-consumer.js";
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

function c(_ref) {
  var c = _ref.context,
      e = _ref.subscribe;
  return function (o, n) {
    "object" == _typeof(n) ? n.addInitializer(function () {
      var _this = this;

      new t(this, {
        context: c,
        callback: function callback(t) {
          _this[n.name] = t;
        },
        subscribe: e
      });
    }) : o.constructor.addInitializer(function (o) {
      new t(o, {
        context: c,
        callback: function callback(t) {
          o[n] = t;
        },
        subscribe: e
      });
    });
  };
}

export { c as consume };